import { render, staticRenderFns } from "./order.vue?vue&type=template&id=bd66ae7c&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd66ae7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd66ae7c')) {
      api.createRecord('bd66ae7c', component.options)
    } else {
      api.reload('bd66ae7c', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=bd66ae7c&scoped=true", function () {
      api.rerender('bd66ae7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/paidMembers/order.vue"
export default component.exports